import { render, staticRenderFns } from "./PatientsDeleteModal.vue?vue&type=template&id=98b0acf6&scoped=true&"
import script from "./PatientsDeleteModal.vue?vue&type=script&lang=js&"
export * from "./PatientsDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientsDeleteModal.vue?vue&type=style&index=0&id=98b0acf6&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b0acf6",
  null
  
)

export default component.exports